import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Billable } from '@feathr/blackbox';
import { Button, Form } from '@feathr/components';

import LegacyAddressInput from '../LegacyAddressInput';

interface IProps {
  billable: Billable;
  onNext: () => void;
  onPrevious: () => void;
}

function BillableStepTwo({ billable, onNext, onPrevious }: IProps) {
  return (
    <Form
      actions={[
        <Button key={'next'} onClick={onNext} type={'primary'}>
          Next
        </Button>,
        <Button key={'previous'} onClick={onPrevious} type={'naked'}>
          Previous
        </Button>,
      ]}
      label={'Billing configuration settings: Billing address'}
    >
      <LegacyAddressInput<Billable> attribute={'address'} model={billable} />
    </Form>
  );
}

export default observer(BillableStepTwo);
